import { useDispatch, useSelector } from "react-redux";
import ProjectCard from "./ProjectCard";
import { forwardRef, useEffect } from "react";
import { setActiveSection } from "../../store";

function WorksSection({ preventIntersectionObserver }, ref) {
  const dispatch = useDispatch();

  /**
   * This is a callback to begin the observation of the div when the component first renders.
   */
  useEffect(() => {
    /**
     * An interaction observer object that allows us to monitor any interaction between the section's
     * div, and the viewport (visible area). It will make the section active when it intersects the
     * viewport.
     */
    const observer = new IntersectionObserver(
      (data) => {
        if (!preventIntersectionObserver.current && data[0].isIntersecting)
          dispatch(setActiveSection("works"));
      },
      {
        root: null,
        threshold: [0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8],
        rootMargin: "0px 5px 0px 0px",
      }
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, dispatch, preventIntersectionObserver]);

  const { projectData } = useSelector((store) => store.app);
  const projectCards = projectData.map((data, index) => {
    return (
      <ProjectCard
        key={index}
        projectData={data}
        projectIndex={index}
        className="mb-5"
      />
    );
  });

  return (
    <div className="h-max w-full my-5" ref={ref}>
      <h1 className="text-white text-3xl pl-3 mb-7">My Projects</h1>
      <div className="flex flex-col items-center">{projectCards}</div>
    </div>
  );
}

export default forwardRef(WorksSection);
